import React, { forwardRef } from 'react';

const TextArea = forwardRef(
  (
    {
      className,
      min,
      max,

      error,
      label,
      id,
      adornment,
      required,
      maxLength,
      backgroundColor,
      height,
      ...props
    },
    ref
  ) => {
    return (
      <div className="flex flex-col items-start  ">
        {!!label && (
          <label
            htmlFor={id}
            className="font-averta mb-2 text-sm font-bold text-primary-text text-start flex items-center gap-1">
            {label}
            {required && (
              <>
                <span className="text-error pl-2">*</span>
                <span className="text-xs font-normal text-gray-600">
                  Required
                </span>
              </>
            )}
          </label>
        )}
        <div className="relative w-full flex flex-col items-start">
          <textarea
            id={id}
            className={`${
              error ? 'border-error bg-error-light' : 'border-input'
            }  flex p-0 m-0 box-border text-primary-text outline-none appearance-none bg-transparent w-full rounded-md border border-solid bg-background px-3 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-border-secondary focus-visible:outline-none focus-visible:border-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50  hover:border-primary-text focus:border-primary-text transition-colors duration-200  ${className}`}
            style={{ background: backgroundColor, height }}
            ref={ref}
            min={min}
            max={max}
            maxLength={maxLength}
            {...props}
          />
        </div>
        {!!error && <span className="text-xs text-error mt-1">{error}</span>}
      </div>
    );
  }
);
TextArea.displayName = 'TextArea';

export { TextArea };
